<template>
  <div class="ZH_EN fl">
    <div class="lang-title" :class="active.lang">
      <span class="lang">{{active.name}}</span>
    </div>
    <ul class="lang_select">
      <p class="list_line"></p>
      <li v-for="v in list" :key="v.id" :class="v.lang" @click="changLang(v)">
        <span class="lang">{{v.name}}</span>
      </li>
      <p class="list_line_b"></p>
    </ul>
  </div>
</template>

<script>
import {list} from '@/lang/i18n'
import cookies from 'vue-cookies'
export default {
  inject:['$viewReload'],
  data() {
    return {
      list
    };
  },
  methods: {
    changLang(v) {
      this.$i18n.locale=v.lang;
      window.$getOnceCache={}
      cookies.set('LanguageType',v.id,'2y')
      this.$viewReload()
    },
  },
  computed:{
    active(){
      return this.list.filter(v=>v.lang==this.$i18n.locale)[0]
    }
  }
};
</script>


<style lang="less" scoped>
.ZH_EN {
  width: 151px;
  margin-right: 13px;
  margin-left: 3px;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
  &:hover {
    .lang_select {
      display: block;
    }
  }
  .lang-title {
    height: 80px;
    line-height: 80px;
    padding-left: 20px;
    .lang {
      position: relative;
      padding-left: 20px;
      &::after {
        width: 0;
        height: 0;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid #7b7b7c;
        content: "";
        position: absolute;
        right: -15px;
        top: 50%;
        margin-top: -2px;
      }
    }
  }

  .lang_select {
    position: absolute;
    left: 0;
    top: 70px;
    z-index: 20;
    display: none;
    li {
      width: 151px;
      height: 40px;
      background: rgba(255, 255, 255, 1);
      text-align: center;
      &:hover {
        background: rgba(246, 249, 255, 1);
      }
    }
  }
  .lang {
    background: url(../assets/public_language.png) left no-repeat;
    background-size: 16px;
    padding-left: 36px;
    display: inline-block;
    background-position: 0 0px;
    font-size: 14px;
    line-height: 16px;
    color: rgba(123, 123, 124, 1);
    height: 16px;
    margin: 12px 0;
  }

  .hk {
    .lang {
      background-position: 0 -16px;
    }
  }
  .en {
    .lang {
      background-position: 0 -32px;
    }
  }
  .list_line {
    height: 4px;
    background: linear-gradient(
      90deg,
      rgba(129, 169, 250, 1) 0%,
      rgba(74, 112, 242, 1) 100%
    );
    border-radius: 4px 4px 0px 0px;
  }
  .list_line_b {
    height: 4px;
    border-radius: 0px 0px 4px 4px;
    background-color: #fff;
  }
}
</style>
